import { NgModule } from '@angular/core';
import { RouterModule, UrlSerializer } from '@angular/router';

import { CustomUrlSerializer } from '@core/shared';
import { CoreRoutes } from '@core/core.routes';
import { ExtensionRoutes } from './extension/extension.routes';

let routes = [...ExtensionRoutes, ...CoreRoutes]


@NgModule({
  imports: [RouterModule.forRoot(routes,
    { scrollPositionRestoration: 'enabled', relativeLinkResolution: 'legacy', onSameUrlNavigation: 'reload' })
  ],
  providers: [
    { provide: UrlSerializer, useClass: CustomUrlSerializer }
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
